<template>
  <span class="huge-savings-badge">Huge Savings</span>
</template>

<script>
export default {
  name: 'HugeSavingsBadge'
}
</script>

<style scoped>
/* Huge Savings badge — solid green pill, sits under the price. Default (non-sale) variant. */
.huge-savings-badge {
  display: inline-block;
  margin-top: 3px;
  margin-bottom: 6px;
  background-color: #00c042;
  color: #fff;
  font-family: var(--satoshi, 'Satoshi', sans-serif);
  font-size: 8px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  pointer-events: none;
}
</style>
